import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/automation/router/router.js';
      import {RouterAlternativeIcon} from '@oicl/openbridge-webcomponents/dist/automation/router/router.js';
import {SquaredVariant} from '@oicl/openbridge-webcomponents/dist/automation/automation-button/abstract-automation-button-squared.js';
import {AutomationButtonReadoutPosition, AutomationButtonPositioning, AutomationButtonDirection} from '@oicl/openbridge-webcomponents/dist/automation/automation-button/automation-button.js';
import {AutomationButtonReadoutStackSize} from '@oicl/openbridge-webcomponents/dist/components/automation-button-readout-stack/automation-button-readout-stack.js';
import {ObcAlertFrameType, ObcAlertFrameThickness, ObcAlertFrameStatus} from '@oicl/openbridge-webcomponents/dist/components/alert-frame/alert-frame.js';
import {CircularProgressMode} from '@oicl/openbridge-webcomponents/dist/building-blocks/circular-progress/circular-progress.js';

      export interface Props {
     alternativeIcon?: RouterAlternativeIcon;
     on?: boolean;
     variant?: SquaredVariant;
     showReadoutStack?: boolean;
     hasIdTag?: boolean;
     readoutPosition?: AutomationButtonReadoutPosition;
     readoutSize?: AutomationButtonReadoutStackSize;
     positioning?: AutomationButtonPositioning;
     alert?: boolean;
     alertFrameType?: ObcAlertFrameType;
     alertFrameThickness?: ObcAlertFrameThickness;
     alertFrameStatus?: ObcAlertFrameStatus;
     showAlertCategoryIcon?: boolean;
     showAlertIcon?: boolean;
     progress?: boolean;
     progressMode?: CircularProgressMode;
     progressValue?: number;
     tag?: string;
     direction?: AutomationButtonDirection;
     badgeAuto?: boolean;
     badgeCommandLocked?: boolean;
     badgeDuty?: boolean;
     badgeAlertOff?: boolean
   }

      
  
      export type {RouterAlternativeIcon} from '@oicl/openbridge-webcomponents/dist/automation/router/router.js';
export type {SquaredVariant} from '@oicl/openbridge-webcomponents/dist/automation/automation-button/abstract-automation-button-squared.js';
export type {AutomationButtonReadoutPosition, AutomationButtonPositioning, AutomationButtonDirection} from '@oicl/openbridge-webcomponents/dist/automation/automation-button/automation-button.js';
export type {AutomationButtonReadoutStackSize} from '@oicl/openbridge-webcomponents/dist/components/automation-button-readout-stack/automation-button-readout-stack.js';
export type {ObcAlertFrameType, ObcAlertFrameThickness, ObcAlertFrameStatus} from '@oicl/openbridge-webcomponents/dist/components/alert-frame/alert-frame.js';
export type {CircularProgressMode} from '@oicl/openbridge-webcomponents/dist/building-blocks/circular-progress/circular-progress.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcRouter',
  props: {
    alternativeIcon: {},
    on: { type: Boolean },
    variant: {},
    showReadoutStack: { type: Boolean },
    hasIdTag: { type: Boolean },
    readoutPosition: {},
    readoutSize: {},
    positioning: {},
    alert: { type: Boolean },
    alertFrameType: {},
    alertFrameThickness: {},
    alertFrameStatus: {},
    showAlertCategoryIcon: { type: Boolean },
    showAlertIcon: { type: Boolean },
    progress: { type: Boolean },
    progressMode: {},
    progressValue: {},
    tag: {},
    direction: {},
    badgeAuto: { type: Boolean },
    badgeCommandLocked: { type: Boolean },
    badgeDuty: { type: Boolean },
    badgeAlertOff: { type: Boolean }
  },
  setup(__props: any) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-router',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})